import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { ResetPasswordTokenGuard } from './auth/reset-password-token.guard';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { PageDashboardComponent } from './components/page-dashboard/page-dashboard.component';
import { PageHomeComponent } from './components/page-home/page-home.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';
import { NOT_ADMIN_PERMISSION } from './models/auth-user.model';
import { JoinOperator } from './models/permission.model';

const routes: Routes = [
  {
    path: '',
    component: PageDashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: PageHomeComponent },
      {
        path: 'users',
        loadChildren: () => import('./users/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: {
            permissions: ['users_management'],
            joinOperator: JoinOperator.AND
          }
        }
      },
      {
        path: 'roles',
        loadChildren: () => import('./roles/role.module').then(m => m.RoleModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: {
            permissions: ['roles_management'],
            joinOperator: JoinOperator.AND
          }
        }
      },
      {
        path: 'medical-centers',
        loadChildren: () => import('./medical-centers/medical-center.module').then(m => m.MedicalCenterModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: {
            permissions: ['gestione_centri', 'viewer'],
            joinOperator: JoinOperator.OR
          }
        }
      },
      {
        path: 'patients',
        loadChildren: () => import('./patients/patient.module').then(m => m.PatientModule),
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: {
            permissions: ['gestione_pazienti', 'viewer', NOT_ADMIN_PERMISSION],
            joinOperator: JoinOperator.OR
          }
        }
      },
    ]
  },
  { path: 'login', component: LoginPageComponent },
  { path: 'resetPassword', component: ResetPasswordPageComponent, canActivate: [ResetPasswordTokenGuard] },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
